import SpanEvent from "../../../../contents/docs/llm-analytics/_snippets/span-event.mdx";
import * as React from 'react';
export default {
  SpanEvent,
  React
};